/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StatusC7eEnum } from './StatusC7eEnum';
import {
    StatusC7eEnumFromJSON,
    StatusC7eEnumFromJSONTyped,
    StatusC7eEnumToJSON,
    StatusC7eEnumToJSONTyped,
} from './StatusC7eEnum';
import type { AerialImagesListCenter } from './AerialImagesListCenter';
import {
    AerialImagesListCenterFromJSON,
    AerialImagesListCenterFromJSONTyped,
    AerialImagesListCenterToJSON,
    AerialImagesListCenterToJSONTyped,
} from './AerialImagesListCenter';

/**
 * PlumeImage representation for the unmatched data map.
 * 
 * Same shape as `PlumeImageSerializer`, without the queries it runs for the
 * emission record fields.
 * @export
 * @interface UnmatchedPlumeImage
 */
export interface UnmatchedPlumeImage {
    /**
     * 
     * @type {string}
     * @memberof UnmatchedPlumeImage
     */
    readonly id: string;
    /**
     * 
     * @type {string}
     * @memberof UnmatchedPlumeImage
     */
    originalImage: string;
    /**
     * 
     * @type {string}
     * @memberof UnmatchedPlumeImage
     */
    tiledImage: string;
    /**
     * Returns bounds of image polygon.
     * @type {Array<any>}
     * @memberof UnmatchedPlumeImage
     */
    readonly bounds: Array<any>;
    /**
     * 
     * @type {AerialImagesListCenter}
     * @memberof UnmatchedPlumeImage
     */
    center?: AerialImagesListCenter | null;
    /**
     * 
     * @type {StatusC7eEnum}
     * @memberof UnmatchedPlumeImage
     */
    status?: StatusC7eEnum;
    /**
     * 
     * @type {Date}
     * @memberof UnmatchedPlumeImage
     */
    takenAt: Date;
    /**
     * 
     * @type {Array<Date>}
     * @memberof UnmatchedPlumeImage
     */
    readonly matchedAt: Array<Date>;
    /**
     * If this should be hidden in the map by default.
     * @type {boolean}
     * @memberof UnmatchedPlumeImage
     */
    readonly defaultHide: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UnmatchedPlumeImage
     */
    isTiled?: boolean;
}



/**
 * Check if a given object implements the UnmatchedPlumeImage interface.
 */
export function instanceOfUnmatchedPlumeImage(value: object): value is UnmatchedPlumeImage {
    if (!('id' in value) || value['id'] === undefined) return false;
    if ((!('originalImage' in (value as Record<string, any>)) && !('original_image' in (value as Record<string, any>))) || ((value as Record<string, any>)['originalImage'] === undefined && (value as Record<string, any>)['original_image'] === undefined)) return false;
    if ((!('tiledImage' in (value as Record<string, any>)) && !('tiled_image' in (value as Record<string, any>))) || ((value as Record<string, any>)['tiledImage'] === undefined && (value as Record<string, any>)['tiled_image'] === undefined)) return false;
    if (!('bounds' in value) || value['bounds'] === undefined) return false;
    if ((!('takenAt' in (value as Record<string, any>)) && !('taken_at' in (value as Record<string, any>))) || ((value as Record<string, any>)['takenAt'] === undefined && (value as Record<string, any>)['taken_at'] === undefined)) return false;
    if ((!('matchedAt' in (value as Record<string, any>)) && !('matched_at' in (value as Record<string, any>))) || ((value as Record<string, any>)['matchedAt'] === undefined && (value as Record<string, any>)['matched_at'] === undefined)) return false;
    if ((!('defaultHide' in (value as Record<string, any>)) && !('default_hide' in (value as Record<string, any>))) || ((value as Record<string, any>)['defaultHide'] === undefined && (value as Record<string, any>)['default_hide'] === undefined)) return false;
    return true;
}

export function UnmatchedPlumeImageFromJSON(json: any): UnmatchedPlumeImage {
    return UnmatchedPlumeImageFromJSONTyped(json, false);
}

export function UnmatchedPlumeImageFromJSONTyped(json: any, ignoreDiscriminator: boolean): UnmatchedPlumeImage {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'originalImage': json['original_image'],
        'tiledImage': json['tiled_image'],
        'bounds': json['bounds'],
        'center': json['center'] === undefined ? undefined : json['center'] === null ? null : AerialImagesListCenterFromJSON(json['center']),
        'status': json['status'] == null ? undefined : StatusC7eEnumFromJSON(json['status']),
        'takenAt': (new Date(json['taken_at'])),
        'matchedAt': json['matched_at'],
        'defaultHide': json['default_hide'],
        'isTiled': json['is_tiled'] == null ? undefined : json['is_tiled'],
    };
}

export function UnmatchedPlumeImageToJSON(json: any): UnmatchedPlumeImage {
    return UnmatchedPlumeImageToJSONTyped(json, false);
}

export function UnmatchedPlumeImageToJSONTyped(value?: Omit<UnmatchedPlumeImage, 'id'|'bounds'|'matchedAt'|'defaultHide'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'original_image': value['originalImage'],
        'tiled_image': value['tiledImage'],
        'center': AerialImagesListCenterToJSON(value['center']),
        'status': StatusC7eEnumToJSON(value['status']),
        'taken_at': value['takenAt'].toISOString(),
        'is_tiled': value['isTiled'],
    };
}

